export function getControlBlockTemplate(_params: any): any {
  return {};
}
